import { Component, El } from "strudel";

@Component('[data-cp="video"]')
export default class Video {
	init() {
		this.$video.get(0).addEventListener('error', () => {
			if(this.$image.length && this.$video.length) {
				this.$video.get(0).style.display = 'none';
				this.$image.get(0).style.display = 'block';
			}
		});

		this.$video.get(0).addEventListener('waiting', () => {
			if (navigator.connection && navigator.connection.effectiveType) {
				if (navigator.connection.effectiveType === '2g' || navigator.connection.effectiveType === 'slow-2g') {
					if(this.$image.length && this.$video.length) {
						this.$video.get(0).style.display = 'none';
						this.$image.get(0).style.display = 'block';
					}
				}
			}
		});
	}

	@El('[data-video-ref="video"]')
	$video;

	@El('[data-video-ref="image"]')
	$image;
}
